import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsMeasurementResult, PmsMeasurementResult } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsMeasurementResult>
    useData={usePmsMeasurementResult}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
